import React from 'react'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import { Image } from '../../components/_all' 
import './footersimple.scss'

const FooterSimple = ( { properties } ) => {
  const { style, offices, links, copyright} = properties
  const {t} = useTranslation()
  const cssPrefix = `ss-footer--${style}`

  const renderOffices = offices.map( (item, index)  => {
    return (
      <div className={`${cssPrefix}__office`} key={index}>
        <div className={`${cssPrefix}__heading`}>
          <h3>{t(item.city)}</h3> 
          <h4>{t(item.country)}</h4>     
          <div className={`${cssPrefix}__image-container`}>
            <Image src={item.image.path} alt={item.image.alt} />
          </div>
        </div>
      </div>
    )
  }) 

  return ( 
    <div className={`${cssPrefix} neutral`}>
      <div className={`${cssPrefix}__offices`} id='branches'>
        {renderOffices}
      </div>
      <hr/>
      <div className={`${cssPrefix}__container`}>
        <div className={`${cssPrefix}__copyright`}>
          <p>{t(copyright)}</p>
        </div>
      </div>
    </div>
  )
}

export default FooterSimple